// X56: the admin trail is page state (useState 'adminBreadcrumbs', set by each admin page from its setup), so a page
// that never set one showed the previous page's trail. X165 (R76 S1): clearing it here, before the new page's setup
// had run, blanked the bar for up to half a second on every admin navigation (the old page jumped up 49px, then the
// new one landed 49px down). The crumbs now stay put; this only marks that the new page owes its own trail, and the
// client plugin clears a trail still owed once the page has finished rendering (page:finish). A query-only change
// (a tab) owes nothing. The rule itself is utils/adminBreadcrumbTrail (tested).
import {isAdminPathChange} from '~/utils/adminBreadcrumbTrail';

export default defineNuxtRouteMiddleware((to, from) => {
  if (!isAdminPathChange(to, from)) return;
  useState('adminBreadcrumbsPending', () => false).value = true;
});
